import React, { useState, useEffect, useContext } from 'react';
import APopover from 'views/pages/manage/common/a-popover';
import { regex } from 'views/pages/manage/common/constant/regex/index';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { Card } from '@mui/material';
import { useHistory } from 'react-router-dom';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import moment from "moment";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import styles from "./styles.module.scss";
import FilterForm from '../sapPurchaseGrn/FilterForm';
import { getFilterCount } from '../onBoardingMaterialIdSetup/constant';
import { serviceEntryTypes, initialFilter, sesModule, createReqObject, createReqObjForRev, getServiceEntryDropdown } from './constants';
import { useSelector } from "react-redux";
import { UserDetails } from 'appContext';
import ALoader from 'views/pages/manage/common/a-loader';
import Header from './Header';
import MessageDialog from '../sapPurchaseOrder/MessageDialog';
import { ConfirmationDeleteDialog } from 'views/pages/manage/common/commonComponents';
import TableHeader from './TableHeader';
import ListingDialog from './ListingDialog';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ListEditableRows from './ListEditableRows';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ItemListingDialog from './ItemListingDialog';
import { PermissionContext, RolePermissions } from '../../../../../../../appContext';
import { endpoint, pages } from '../../../../common/constant';
import { failureToast } from '../../../../common/utils/methods/toasterFunctions/function';


const ServiceEntrySheet = () => {

    const history = useHistory();
    const [isLoading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState({ ...initialFilter });
    const [filterCount, setFilterCount] = useState(getFilterCount({ ...globalFilter }, ['poNumber']));
    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [headerResp, setHeaderResp] = useState({})
    const [warning, setWarning] = useState();
    const [response, setResponse] = useState(null);
    const [fileData, setFileData] = useState({});
    const [serviceEntryType, setserviceEntryType] = useState();
    const userData = useContext(UserDetails);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [poData, setPoData] = useState([]);
    const [serviceRows, setServiceRows] = useState([]);
    const [selectedPoNumber, setSelectedPoNumber] = useState(null);
    const [poItemsForListing, setPoItemsForListing] = useState([]);
    const [showItemDialog, setShowItemDialog] = useState(false);
    const [isDownloaded, setIsDownloaded] = useState(false);

    const sheetType = serviceEntryType?.value || '';

    const activePlant = useSelector(
        (state) => state.globalData.masterDropdowns
    ).businessArea?.map(({ sapPlantId, sapBusinessArea }) => ({
        label: sapBusinessArea,
        value: sapPlantId,
    }));

    const sapEntrySheetPermission = RolePermissions(
        useContext(PermissionContext),
        pages["sapEntrySheet"]["id"]);

    const esDropdown = getServiceEntryDropdown(sapEntrySheetPermission);

    const headerFormHandler = (key, val) => {
        setHeaderResp((prev) => ({ ...prev, [key]: val }));
    };

    const filterFormHandler = (key, value) => {
        setGlobalFilter((prev) => ({ ...prev, [key]: value ?? [] }));
    };

    const searchInputHandler = (inputValue) => {
        searchHandler({ poNumber: inputValue, processType: sesModule })
        setFilterCount(0);
        setGlobalFilter({ poNumber: inputValue });
    };

    const crossHandler = () => {
        setGlobalFilter({ ...initialFilter });
        setRows([]);
        setFilterCount(0);
        setHeaderResp({});
        setServiceRows([]);
        setFileData({});
        setPoItemsForListing([]);
        setSelectedPoNumber(null);
        setShowItemDialog(false);
    }

    const sesSearchInputHandler = (inputValue, year) => {
        let plants = activePlant?.map(p => p?.value);
        if (sheetType === 'listSE') {
            sesSearchHandler({ entrySheetNumber: inputValue, year: year, plant: plants });
        } else if (sheetType === 'pendingSE' || sheetType === "ariba") {
            sesSearchHandler({ uuid: inputValue , plant: plants });
        }
    }

    const searchSesHandler = (reqObj) => {
        sesSearchHandler(reqObj)
        setOpen(false);
    }

    const handleSelectAll = (checked) => {
        const updated = serviceRows.map((row) => ({ ...row, isChecked: checked }));
        setServiceRows(updated);
    };

    const sesSearchHandler = async (reqObj) => {
        const url = endpoint?.sap?.ses?.search;
        const method = "post";

        try {
            setLoading(true);
            const resp = await fetchAllPostPromisedData(url, reqObj, method);

            if (resp?.code !== 200) return;
            const data = resp?.data || {};
            const items = data?.serviceList || [];
            if (!(reqObj?.entrySheetNumber || reqObj?.uuid) && ((reqObj?.poNumber && reqObj?.plant)|| reqObj?.plant && reqObj?.dateHigh && reqObj?.dateLow)) {
                //for listing
                if (items.length === 0) {
                    setWarning("No Document found");
                } else {
                    setWarning("");
                    setPoData(items);
                }
                setOpen(true);
                return;
            }
            else {
                const formattedRows = items?.map((item, index) => {
                    const parsedQuantity = parseFloat(item?.quantity?.toString()?.trim());
                    return {
                        ...item,
                        id: index,
                        maxQuantity: !isNaN(parsedQuantity) ? parsedQuantity : 0,
                        netValue: +(item?.quantity) * +(item?.price),

                    };
                });
                const headerObj = data?.header || {};
                if (reqObj?.entrySheetNumber) {
                    filterFormHandler("entrySheetNumber", reqObj.entrySheetNumber);
                    filterFormHandler("year", reqObj?.year);
                }
                else if (reqObj?.uuid) {
                    filterFormHandler("uuid", reqObj.uuid);
                }
                setServiceRows(formattedRows);
                if (Object.keys(headerObj).length > 0) {
                    setFileData(headerObj?.attachment ?? "");
                    const headerRes = {
                        ...headerObj,
                        docDate: moment(headerObj?.docDate?.toString()),
                        postingDate: new Date()
                    };
                    setHeaderResp(headerRes);
                }
            }

        } catch (error) {
            console.error("Error during SES search:", error);
        } finally {
            setLoading(false);
        }
    };

    const searchHandler = async (reqObj) => {
        let url = endpoint?.sap?.grn.poSearch;
        let method = "post";
        try {
            setLoading(true)
            debugger
            const resp = await fetchAllPostPromisedData(url, reqObj, method);

            if (resp?.code == 200) {
                if (reqObj?.poNumber && !reqObj?.itemNo) {
                    const items = resp?.data?.items;
                    if (!items || items.length < 1) {
                        setWarning("No PO Items found");
                    } else {
                        setWarning('');
                        setOpen(false);
                        setPoItemsForListing(items);
                        setSelectedPoNumber(reqObj?.poNumber);
                        setShowItemDialog(true);
                    }
                    return;
                }
                if (!reqObj?.poNumber && !reqObj?.itemNo && reqObj?.plant && reqObj?.dateHigh && reqObj?.dateLow) {
                    //for listing
                    if (!resp?.data?.items || (resp?.data?.items).length < 1) {
                        setWarning("No PO found");
                    }
                    else {
                        setWarning("");
                        setPoData(resp?.data?.items);
                    }
                    setOpen(true);

                }
                else {
                    const res = resp?.data?.items ? (resp?.data?.items).map((Items, index) => {
                        return {
                            ...Items,
                            id: index,
                        }
                    }) : [];

                    const serviceResp = resp?.data?.items?.[0]?.serviceList
                        ? resp.data.items[0].serviceList.map((item, index) => ({
                            ...item,
                            id: index,
                            netValue: +(item?.quantity * item?.price)
                        }))
                        : [];

                    const resHeader = {
                        ...(resp?.data?.header),
                        docDate: moment(resp?.data?.header?.docDate?.toString()),
                        postingDate: new Date()
                    }

                    //if PO no is present then also store this in state
                    if (reqObj?.poNumber && reqObj?.poNumber.trim() !== "") {
                        filterFormHandler("poNumber", reqObj?.poNumber);
                    }

                    setHeaderResp(resHeader);
                    setRows(res);
                    setServiceRows(serviceResp);
                }
            }
        } catch (error) {
            console.log(error)
        }
        finally {
            setLoading(false)
        }
    }

    const reversalHandler = async () => {
        const reqObj = createReqObjForRev(rows, serviceRows, sheetType, headerResp, fileData, globalFilter?.entrySheetNumber);
        const url = endpoint?.sap?.ses?.create;
        try {
            setLoading(true);
            let method = "post";
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            const returnData = resp?.data?.return;
            if (resp?.code == 200) {
                setOpenDeleteDialog(false);
                const isError = resp?.data?.isError == "false" ? false : true;
                if (!isError) {
                    crossHandler();
                    setFilterCount(0);
                    let message = "";
                    if (sheetType === "listSE") {
                        message = `Entry Sheet Number ${resp?.data?.entrySheet} reversed Successfully.`
                    } else if (sheetType === "pendingSE") {
                        message = `GRN with Unique ID ${resp?.data?.uuid} reversed Successfully.`
                    }
                    setResponse({
                        isCopy: true,
                        list: [
                            {
                                id: generateRandomId(),
                                type: "I",
                                messageText: message,
                            },
                        ],
                    });
                }
                else if (returnData?.length) {
                    setResponse((prev) => (
                        {
                            ...prev,
                            isCopy: false,
                            list: returnData?.map((error, index) => ({
                                id: generateRandomId() + index,
                                ...error,
                            }))
                        }
                    ))
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const searchPoHandler = (reqObj) => {
        searchHandler(reqObj);
        setOpen(false);
    }


    const createSesHandler = async () => {
        const reqObj = createReqObject(rows, serviceRows, headerResp, fileData, sheetType, activePlant, globalFilter, userData);
        const url = endpoint?.sap?.ses?.create;
        try {
            setLoading(true);
            let method = "post";
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code == 200) {
                const isError = resp?.data?.isError == "false" ? false : true;
                const returnData = resp?.data?.return;
                if (isError && returnData?.length) {
                    //error response
                    setResponse((prev) => (
                        {
                            ...prev,
                            isCopy: false,
                            entrySheetNumber: resp?.data?.entrySheet,
                            uuid: resp?.data?.uuid,
                            list: returnData?.map((error, index) => ({
                                id: generateRandomId() + index,
                                ...error,
                            }))
                        }
                    ))
                } else {
                    // success response
                    if (isError !== null && isError === false) {
                        let messageText = '';
                        if (resp?.data?.uuid) {
                            messageText = `Pending EntrySheet created successfully with Unique Id ${resp?.data?.uuid}`;
                        } else if (resp?.data?.entrySheet && sheetType === 'listSE') {
                            messageText = `EntrySheet reversed for number ${resp?.data?.entrySheet} for year ${resp?.data?.year}`;
                        } else if (resp?.data?.entrySheet && sheetType === 'pendingSE') {
                            messageText = `EntrySheet successfully posted/approved for number ${resp?.data?.entrySheet}`;
                        } else if (resp?.data?.uuid && sheetType === 'ariba') {
                            messageText = `Ariba Listing successfully created for Unique Id ${resp?.data?.uuid}`
                        }
                        crossHandler();
                        setFilterCount(0);
                        setResponse({
                            isCopy: true,
                            entrySheetNumber: resp?.data?.entrySheet,
                            uuid: resp?.data?.uuid,
                            list: [
                                {
                                    id: generateRandomId(),
                                    type: "S",
                                    messageText: messageText
                                },
                            ],
                        });
                    }
                }
                console.log("error res", response);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const rowFormHandler = (index, key, value) => {
        setServiceRows(rows => {
            let tempRows = [...rows]
            let tempRowsIndex = rows[index]
            tempRows[index] = { ...tempRowsIndex, [key]: value }
            return tempRows;
        })
    }


    const isSaveDisabled = (() => {
        if (sheetType === 'createSE') {
            return (
                !fileData?.attachment ||
                !headerResp?.shortText ||
                !headerResp?.docDate ||
                !headerResp?.postingDate ||
                !headerResp?.reference
            );
        }
        if (sheetType === 'ariba') {
            return (!fileData?.attachment);
        }
        if (sheetType === 'pendingSE') {
            return !(
                headerResp?.approver === userData?.employeeId &&
                headerResp?.approvalStatus === 'P'
            );
        }
        // if (sheetType === 'listSE') {
        //     return (headerResp?.mvtType?.value !== '102')
        // }
        return false;
    })();

    const netPrice = serviceRows?.reduce((acc, curr) => {
        return acc + (+(curr?.netValue)?.toFixed(2))
    }, 0)

    const serviceSheetBasedSearch = () => {
        if (sheetType === "createSE") {
            searchInputHandler(globalFilter?.poNumber);
        } else if (sheetType === "listSE") {
            sesSearchInputHandler(globalFilter?.entrySheetNumber, globalFilter?.year);
        } else if (sheetType === "pendingSE" || sheetType === 'ariba') {
            sesSearchInputHandler(globalFilter?.uuid);
        }
    }

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            serviceSheetBasedSearch();
        }
    }

    return (
        <>
            <Card className="mx-3 p-2">
                <div className='d-flex justify-content-between mb-4'>
                    <div>
                        <BackArrow className='mr-2 cursor' onClick={() => history.goBack()} />
                        <h3 className='d-inline'>{sheetType === 'createSE' ? "Create Service Entry" : 'Display Service Entry'}</h3>
                    </div>

                    <div className={`w-25 ${styles["header-padding"]}`} >
                        <AAutoComplete
                            currentValue={serviceEntryType}
                            handleChange={(value) => {
                                setserviceEntryType(value)
                                setRows([]);
                                setServiceRows([]);
                                setHeaderResp({});
                                setFileData({});
                                setGlobalFilter({ ...initialFilter });
                                setFilterCount(0);
                            }}
                            items={esDropdown}
                            isMulti={false}
                            placeholder={"Please Select Type"}
                        />
                    </div>

                    <div className="d-flex justify-content-between" style={{ columnGap: "10px" }}>
                        <div style={{ width: "fit-content" }}>
                            <AInput
                                style={{ width: '320px', height: '30px' }}
                                value={
                                    sheetType === "createSE"
                                        ? globalFilter?.poNumber
                                        : sheetType === "listSE"
                                            ? globalFilter?.entrySheetNumber
                                            : (sheetType === "pendingSE" || sheetType === 'ariba')
                                                ? globalFilter?.uuid
                                                : ""
                                }
                                placeholder={
                                    sheetType === "createSE"
                                        ? "Enter PO Number"
                                        : sheetType === "listSE"
                                            ? "Enter EntrySheet Number"
                                            : (sheetType === "pendingSE" || sheetType === 'ariba')
                                                ? "Enter Unique ID"
                                                : "Enter Value"
                                }
                                handler={(value) => {
                                    if (!sheetType) return failureToast("Please Select type");
                                    if (sheetType === "createSE") {
                                        filterFormHandler("poNumber", value);
                                    } else if (sheetType === "listSE") {
                                        filterFormHandler("entrySheetNumber", value);
                                    } else if (sheetType === "pendingSE" || sheetType === 'ariba') {
                                        filterFormHandler("uuid", value);
                                    }
                                }}
                                crossIcon={true}
                                rightSearchIcon={true}
                                searchIconClickHandler={() => {
                                    if (sheetType === "createSE") {
                                        searchInputHandler(globalFilter?.poNumber);
                                    } else if (sheetType === "listSE") {
                                        sesSearchInputHandler(globalFilter?.entrySheetNumber, globalFilter?.year);
                                    } else if (sheetType === "pendingSE" || sheetType === 'ariba') {
                                        sesSearchInputHandler(globalFilter?.uuid);
                                    }
                                }}
                                onKeyDown={onKeyDownHandler}
                                crossHandler={crossHandler}
                                regex={(sheetType === "createSE" || sheetType === 'listSE') ? regex.numeric : (sheetType === "pendingSE" || sheetType === 'ariba') ? regex?.alphaNumeric : ''}

                            />
                        </div>

                        <APopover
                            buttonComponent={(openPopover, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={openPopover}
                                    size="xs"
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            : styles),
                                    }}
                                >
                                    Filter {filterCount > 0 && <>( {filterCount} )</>}
                                </AButton>
                            )}
                            menuComponent={(closePopup) =>
                                <FilterForm
                                    closePopup={closePopup}
                                    dropdownData={activePlant}
                                    globalFilter={globalFilter}
                                    setGlobalFilter={setGlobalFilter}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    filterFormHandler={filterFormHandler}
                                    searchHandler={sheetType === "createSE" ? searchHandler : searchSesHandler}
                                    grnType={sheetType}
                                    userData={userData}
                                    processType={sesModule}
                                    crossHandler={crossHandler}
                                />
                            }
                        />
                    </div>
                </div>

                {isLoading && <ALoader position='fixed' />}
                {(sheetType === 'createSE' ? rows?.length == 0 : serviceRows?.length == 0) && (<NoRowOverlay message={isLoading ? "Loading..." : null} />)}
                {(rows?.length > 0 || serviceRows?.length > 0) && (
                    <>
                        <Header
                            headerRows={headerResp}
                            headerFormHandler={headerFormHandler}
                            fileData={fileData}
                            setFileData={setFileData}
                            serviceEntryType={sheetType}
                            itemNo={rows?.length > 0 ? rows[0]?.itemNo : 0}
                            plant={sheetType === 'createSE' ? rows[0]?.plant : headerResp?.plant}
                            netPrice={netPrice}
                            setIsDownloaded={setIsDownloaded}
                        />
                        <div className={`${styles["table-container"]}`} >
                            <TableHeader rows={serviceRows} serviceEntryType={sheetType} handleSelectAll={handleSelectAll} />
                            <ListEditableRows rows={serviceRows} serviceEntryType={sheetType} rowFormHandler={rowFormHandler} />
                        </div>

                        <div className="d-flex justify-content-start mt-4">
                            <AButton
                                variant={
                                    sheetType === "createSE"
                                        ? "primary_filled"
                                        : sheetType === "listSE"
                                            ? "outline_danger"
                                            : (sheetType === "pendingSE" || sheetType === 'ariba')
                                                ? "primary_filled"
                                                : "outline_danger"
                                }
                                onClick={() => {
                                    if (sheetType === "createSE" || sheetType === "pendingSE" || sheetType === "ariba") {
                                        if (sheetType === "pendingSE" && !isDownloaded) {
                                            failureToast("Please download attachment first before approving");
                                            return;
                                        }
                                        createSesHandler();
                                    } else {
                                        setOpenDeleteDialog(true);
                                    }
                                }}
                                size="xs"
                                disabled={isSaveDisabled}
                            >
                                {sheetType === "createSE"
                                    ? "Create Sheet"
                                    : sheetType === "listSE"
                                        ? "Cancel Sheet"
                                        : sheetType === "pendingSE"
                                            ? "Approval"
                                            : sheetType === "ariba" ? "Create" : "Action"}
                            </AButton>

                            {sheetType === "pendingSE" && (
                                <AButton
                                    variant="outline_danger"
                                    onClick={() => { reversalHandler() }}
                                    size="xs"
                                >
                                    Cancel Approval
                                </AButton>
                            )}
                        </div>
                    </>
                )}

            </Card>

            {!isLoading && (
                <ListingDialog
                    rows={poData}
                    open={open}
                    setOpen={setOpen}
                    title={sheetType === 'createSE' ? 'PO Listing' : sheetType === 'listSE' ? "Entry Sheet Number" : sheetType === 'ariba' ? "UUID - EntrySheetNumber" : "Listing"}
                    listingKey={sheetType === 'createSE' ? 'poNumber' : sheetType === "listSE" ? "entrySheetNumber" : (sheetType === "pendingSE" || sheetType === 'ariba') ? "uuid" : ""}
                    clickSearchHandler={sheetType === 'createSE' ? searchPoHandler : searchSesHandler}
                    warningData={warning}
                    // yearKey={sheetType === 'listSE' && 'year'}
                    vendorKey={sheetType === 'createSE' && 'vendor'}
                    receivingVendorKey={["createSE", "listSE", "pendingSE", "ariba"].includes(sheetType) && 'receivingVendor'}
                    processType={sesModule}
                    serviceEntryType={sheetType}
                    includeEntrysheet={sheetType === 'ariba' ? true : false}
                    entrysheetKey={"entrySheetNumber"}
                    activePlant={activePlant}
                    globalFilter={globalFilter}
                />
            )}

            {!isLoading && (
                <ItemListingDialog
                    open={showItemDialog}
                    setOpen={setShowItemDialog}
                    items={poItemsForListing}
                    title="Select PO Item Number"
                    onItemSelect={(selectedItemNo) => {
                        searchHandler({
                            poNumber: selectedPoNumber,
                            processType: sesModule,
                            itemNo: selectedItemNo,
                            // processType: sesModule,
                        });
                    }}
                />
            )}

            {response && !isLoading && (
                <MessageDialog
                    rows={response?.list}
                    setErrorResponse={setResponse}
                    loading={isLoading}
                    errorKey={"type"}
                    msgLabelKey={"messageText"}
                    prNo={response?.entrySheetNumber || response?.uuid}
                    showClipboard={response?.isCopy}
                />
            )}

            <ConfirmationDeleteDialog
                isOpen={openDeleteDialog}
                setIsOpen={setOpenDeleteDialog}
                onAgree={() => { reversalHandler() }}
                onDisagree={() => setOpenDeleteDialog(false)}
                headerMsg={'Confirm Reverse'}
                msg={`Are you sure you want to reverse whole Sheet?`}
            />
        </>
    )
}

export default ServiceEntrySheet   